var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wordList",style:(_vm.wordListStyle)},_vm._l((_vm.puzzle.words),function(word,index){return _c('div',{key:index,staticClass:"word"},[_vm._v(" "+_vm._s(word)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }